import { createBrowserRouter } from "react-router-dom";
import { Layout } from "./app/Layout";
import { Home } from "./routes/Home";
import { Login } from "./routes/Login";
import { Register } from "./routes/Register";
import { CreateProfile } from "./routes/CreateProfile";
import { EditProfile } from "./routes/EditProfile";
import { Verification } from "./routes/Verification";
import { AdminVerification } from "./routes/AdminVerification";
import { AdminUsers } from "./routes/AdminUsers";
import { AdminModeration } from "./routes/AdminModeration";
import { Disputes } from "./routes/Disputes";
import { AdminDisputes } from "./routes/AdminDisputes";
import { Styleguide } from "./routes/Styleguide";
import { Feed } from "./routes/Feed";
import { Communities } from "./routes/Communities";
import { Community } from "./routes/Community";
import { Groups } from "./routes/Groups";
import { Group } from "./routes/Group";
import { Pipeline } from "./routes/Pipeline";
import { CRM } from "./routes/CRM";
import { Auctions } from "./routes/Auctions";
import { Auction } from "./routes/Auction";
import { MyAuctions } from "./routes/MyAuctions";
import { Marketplace } from "./routes/Marketplace";
import { Listing } from "./routes/Listing";
import { MyListings } from "./routes/MyListings";
import { Security } from "./routes/Security";
import { Privacy } from "./routes/Privacy";
import { Connections } from "./routes/Connections";
import { ProfileView } from "./routes/ProfileView";
import { MessagesLayout, MessagesEmpty } from "./routes/MessagesLayout";
import { Conversation } from "./routes/Conversation";
import { NewConversation } from "./routes/NewConversation";
import { JobBoard } from "./routes/JobBoard";
import { PostJob } from "./routes/PostJob";
import { MyJobs } from "./routes/MyJobs";
import { JobDetail } from "./routes/JobDetail";
import { MyApplications } from "./routes/MyApplications";
import { LoadBoard } from "./routes/LoadBoard";
import { PostLoad } from "./routes/PostLoad";
import { MyLoads } from "./routes/MyLoads";
import { Dispatch } from "./routes/Dispatch";
import { Fleet } from "./routes/Fleet";
import { Compliance } from "./routes/Compliance";
import { Logbook } from "./routes/Logbook";
import { Incidents } from "./routes/Incidents";
import { Maintenance } from "./routes/Maintenance";
import { Assets } from "./routes/Assets";
import { Fuel } from "./routes/Fuel";
import { Telematics } from "./routes/Telematics";
import { CarrierPacket } from "./routes/CarrierPacket";
import { Marketing } from "./routes/Marketing";
import { Referrals } from "./routes/Referrals";
import { Automations } from "./routes/Automations";
import { Integrations } from "./routes/Integrations";
import { LoadDetail } from "./routes/LoadDetail";
import { MyBids } from "./routes/MyBids";
import { AuthCallback } from "./routes/AuthCallback";
import { Settings } from "./routes/Settings";
import { Analytics } from "./routes/Analytics";
import { MyProfiles } from "./routes/MyProfiles";
import { Notifications } from "./routes/Notifications";
import { Billing } from "./routes/Billing";
import { Directory } from "./routes/Directory";
import { Support } from "./routes/Support";
import { SupportTicket } from "./routes/SupportTicket";
import { AdminSupport } from "./routes/AdminSupport";
import { AdminFeedback } from "./routes/AdminFeedback";
import { AdminSecurity } from "./routes/AdminSecurity";
import { AdminHome } from "./routes/AdminHome";
import { AdminAudit } from "./routes/AdminAudit";
import { AdminFlags } from "./routes/AdminFlags";
import { Organizations } from "./routes/Organizations";
import { AcceptInvite } from "./routes/AcceptInvite";
import { Invoices } from "./routes/Invoices";
import { Payments } from "./routes/Payments";
import { NotFound } from "./routes/NotFound";
import { RouteError } from "./components/RouteError";
import { ProtectedRoute } from "./auth/ProtectedRoute";

export const router = createBrowserRouter([
  { path: "/login", element: <Login />, errorElement: <RouteError /> },
  { path: "/register", element: <Register />, errorElement: <RouteError /> },
  { path: "/auth/callback", element: <AuthCallback />, errorElement: <RouteError /> },
  { path: "/packet/:token", element: <CarrierPacket />, errorElement: <RouteError /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <Layout />,
        errorElement: <RouteError />,
        children: [
          { index: true, element: <Home /> },
          { path: "profiles/new", element: <CreateProfile /> },
          { path: "profiles/:id/edit", element: <EditProfile /> },
          { path: "jobs", element: <JobBoard /> },
          { path: "jobs/new", element: <PostJob /> },
          { path: "jobs/mine", element: <MyJobs /> },
          { path: "jobs/:id", element: <JobDetail /> },
          { path: "applications", element: <MyApplications /> },
          { path: "loads", element: <LoadBoard /> },
          { path: "loads/new", element: <PostLoad /> },
          { path: "loads/mine", element: <MyLoads /> },
          { path: "dispatch", element: <Dispatch /> },
          { path: "fleet", element: <Fleet /> },
          { path: "compliance", element: <Compliance /> },
          { path: "logbook", element: <Logbook /> },
          { path: "incidents", element: <Incidents /> },
          { path: "maintenance", element: <Maintenance /> },
          { path: "assets", element: <Assets /> },
          { path: "fuel", element: <Fuel /> },
          { path: "telematics", element: <Telematics /> },
          { path: "loads/:id", element: <LoadDetail /> },
          { path: "bids", element: <MyBids /> },
          { path: "verify", element: <Verification /> },
          { path: "security", element: <Security /> },
          { path: "admin/verification", element: <AdminVerification /> },
          { path: "admin/users", element: <AdminUsers /> },
          { path: "admin/moderation", element: <AdminModeration /> },
          { path: "admin/disputes", element: <AdminDisputes /> },
          { path: "admin/support", element: <AdminSupport /> },
          { path: "admin", element: <AdminHome /> },
          { path: "admin/feedback", element: <AdminFeedback /> },
          { path: "admin/security", element: <AdminSecurity /> },
          { path: "admin/audit", element: <AdminAudit /> },
          { path: "admin/flags", element: <AdminFlags /> },
          { path: "privacy", element: <Privacy /> },
      { path: "analytics", element: <Analytics /> },
      { path: "profiles", element: <MyProfiles /> },
      { path: "notifications", element: <Notifications /> },
      { path: "billing", element: <Billing /> },
      { path: "feed", element: <Feed /> },
      { path: "communities", element: <Communities /> },
      { path: "communities/:slug", element: <Community /> },
      { path: "pipeline", element: <Pipeline /> },
      { path: "crm", element: <CRM /> },
      { path: "marketing", element: <Marketing /> },
      { path: "automations", element: <Automations /> },
      { path: "referrals", element: <Referrals /> },
      { path: "integrations", element: <Integrations /> },
      { path: "marketplace", element: <Marketplace /> },
      { path: "marketplace/mine", element: <MyListings /> },
      { path: "marketplace/:id", element: <Listing /> },
      { path: "auctions", element: <Auctions /> },
      { path: "auctions/mine", element: <MyAuctions /> },
      { path: "auctions/:id", element: <Auction /> },
      { path: "network", element: <Directory /> },
      { path: "network/:type", element: <Directory /> },
      { path: "invoices", element: <Invoices /> },
      { path: "payments", element: <Payments /> },
      { path: "disputes", element: <Disputes /> },
      { path: "styleguide", element: <Styleguide /> },
      { path: "support", element: <Support /> },
      { path: "support/:id", element: <SupportTicket /> },
      { path: "organizations", element: <Organizations /> },
      { path: "orgs/accept", element: <AcceptInvite /> },
      { path: "settings", element: <Settings /> },
      { path: "settings/:section", element: <Settings /> },
          { path: "connections", element: <Connections /> },
          { path: "p/:id", element: <ProfileView /> },
          { path: "groups", element: <Groups /> },
          { path: "groups/:id", element: <Group /> },
          {
            path: "messages",
            element: <MessagesLayout />,
            children: [
              { index: true, element: <MessagesEmpty /> },
              { path: "to/:profileId", element: <NewConversation /> },
              { path: ":id", element: <Conversation /> },
            ],
          },
          { path: "*", element: <NotFound /> },
        ],
      },
    ],
  },
]);
